// extracted by mini-css-extract-plugin
module.exports = {"previousNextCarousel":"bl_dg","headings":"bl_dh","title":"bl_S","controlsContainer":"bl_dj","control":"bl_dk"};